import { CrudList } from '../shared/CrudPage';
import { designationService } from '@kss/api';
import type { Designation, DesignationCreate, DesignationFilter } from '@kss/api';

export default function AllDesignations() {
  return (
    <CrudList<Designation, DesignationCreate, DesignationFilter>
      title="Designations"
      newLabel="New designation"
      service={designationService}
      idKey="designationId"
      labelKey="name"
      basePath="/panel/designations"
      columns={[
        { accessor: 'code', title: 'Code', width: 120 },
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'level' as never, title: 'Level', width: 90 },
      ]}
    />
  );
}
